import $ from 'jquery';
import openBasket from './open-basket';
import closeBasket from './close-basket';
import BasketSummary from './BasketSummary';

const SELECTORS = {
  openButtons: '.mobile-site-basket-open, .js-v2-basket-mobile-open',
  closeButton: '.js-v2-basket-mobile-close',
};

export default class MobileBasketManager {
  init() {
    new BasketSummary();
    $(SELECTORS.openButtons).on('click', openBasket);
    $(SELECTORS.closeButton).on('click', closeBasket);
  }
}
